export default __webpack_public_path__ + "static/media/6.171fcbe8.jpg";